import { render } from "./DatatableUserText.vue?vue&type=template&id=49609002"
import script from "./DatatableUserText.vue?vue&type=script&lang=js"
export * from "./DatatableUserText.vue?vue&type=script&lang=js"

import "./DatatableUserText.vue?vue&type=style&index=0&id=49609002&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__